module.exports = "<div class=\"loading\" *ngIf=\"isLoading\">Carregando<span>.</span><span>.</span><span>.</span></div>\r\n<ng-container *ngComponentOutlet=\"dynamicComponent; NgModuleFactory : dynamicModule\"></ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/report-form-dialog/report-form-dialog.html
// module id = ./src/app/reports/report-form-dialog/report-form-dialog.html
// module chunks = main